export default __webpack_public_path__ + "static/media/1364.a6e95331.jpg";